import { useEffect, useState } from 'react'
import i18next from 'i18next'
import { SettingsSection } from '$common/settings-section'
import { SettingsItemWithText } from '$common/settings-item'
import { t } from '$i18n'
import { showCreateSelectLanguageModal } from '$comp/modals/select-language'

export const SettingLanguage = () => {
  const [language, setLanguage] = useState('')

  useEffect(() => {
    if (i18next.language === 'fa')
      setLanguage(t('settings.sections.language.persian'))

    if (i18next.language === 'ar')
      setLanguage(t('settings.sections.language.arabic'))

    if (i18next.language === 'en')
      setLanguage(t('settings.sections.language.english'))
  }, [i18next.language])

  return (
    <>
      <SettingsSection headerText={t('settings.sections.language.title')}>
        <SettingsItemWithText
          text={t('settings.sections.language.selectedLanguage')}
          secondaryText={language}
          onClick={() => showCreateSelectLanguageModal()}
        />
      </SettingsSection>
    </>
  )
}
